import React from 'react'

import type { SdkGetStartedStepCmsContent } from 'core/services/cms/interfaces'

import { DesktopInstallFlowCard } from './DesktopInstallFlowCard'
import { DesktopCardText } from './DesktopCardText'

import styles from './style.module.scss'

interface DesktopCardsProps {
  heading: React.ReactNode
  steps: SdkGetStartedStepCmsContent[]
}

export const DesktopCards: React.FC<DesktopCardsProps> = ({ heading, steps }) => {
  const desktopCards = steps.map((card, index) => {
    const textToUse = card.desktopText || card.text

    return (
      <DesktopInstallFlowCard
        key={index}
        icon={card.iconUrl}
        text={<DesktopCardText text={textToUse} url={card.url} />}
      />
    )
  })

  return (
    <div className={styles.section}>
      {heading}
      <div className={styles.cardsContainer}>{desktopCards}</div>
    </div>
  )
}
